import { NavLink } from "react-router-dom";
import React from "react";
import { Routes } from "../../configurations/config";

export const title = (userDetails) => {
	const inActiveButtonStyle = {
		background: "#F2FBFA",
		color: "#43A3A5",
		border: "1px solid #43A3A5",
		borderRadius: "10px",
		padding: "8px 30px",
		marginRight: "30px",
		font: "13px poppins",
		textDecoration: "none",
	};
	const activeButtonStyle = {
		background: "#43A3A5 no-repeat padding-box",
		color: "white",
		borderRadius: "10px",
		padding: "8px 30px",
		marginRight: "30px",
		border: "none",
		font: "13px poppins",
		fontWeight: "bold",
		textDecoration: "none",
	};
	return (
		<>
			<div className="row">
				<div className="mt-2 mt-lg-0 mt-md-0">
					<NavLink
						isActive={() => {
							return (
								window.location.href[
									window.location.href.lastIndexOf("/") + 1
								] === undefined ||
								window.location.href.indexOf("MyDashboard") !==
									-1
							);
						}}
						style={inActiveButtonStyle}
						activeStyle={activeButtonStyle}
						exact
						to={Routes.MyDashboard}
					>
						My Dashboard
					</NavLink>
				</div>
				{(userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("3")) && (
					<div className="mt-2 mt-lg-0">
						<NavLink
							exact
							style={inActiveButtonStyle}
							activeStyle={activeButtonStyle}
							to={Routes.SpDashboard}
						>
							Supervisor Dashboard
						</NavLink>
					</div>
				)}
				{userDetails.designation.toString() === "4" && (
					<div className="mt-2 mt-lg-0">
						<NavLink
							exact
							style={inActiveButtonStyle}
							activeStyle={activeButtonStyle}
							to={Routes.CMDashboard}
						>
							CM Dashboard
						</NavLink>
					</div>
				)}
			</div>
		</>
	);
};
//-----------------------------------------
//DepartmentIds

export const departmentIds = ["3", "4", "5", "6", "9"];
//-----------
//Date Format
export const APIDateFormat = "YYYY-MM-DD";
export const TableDateFormat = "DD/MM/YYYY";

//Supervisor Timesheet chart
export const SupervisorTimesheetPerformance = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			drilldown: function (e) {
				this.options.legend["enabled"] = true; //legend shows
			},
		},
	},
	accessibility: {
		announceNewData: {
			enabled: true,
		},
	},
	colors: [
		"#3fa3a6",
		"#A3E4D7",
		"#C6D68F",
		"#E6B0AA",
		"tomato",
		"#339900",
		"#99cc33",
		"#ffcc00",
		"#ff9966",
		"#cc3300",
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
	],
	title: {
		text: "",
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	subtitle: {
		text: "",
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 0,
			textAlign: "center",
			color: "#FFFF",
			opacity: 0,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		pie: {
			allowPointSelect: true,
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			size: "60%",
			center: ["20%", "50%"],
		},
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
			dataLabels: {
				enabled: true,
				format: '<span style="font-size:25px;color:white, font-weight: normal">-->{point.name}<br>{point.y:.1f}</span>',
				distance: -40,
				textDecoration: "none",
				style: {
					textDecoration: "none",
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "15px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	},
	tooltip: {
		enabled: true,
		pointFormat: `{point.y}`,
	},

	legend: {
		layout: "vertical",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 500,
		enabled: true,
		y: 5,
		x: -10,
		itemMarginTop: 0,
		itemMarginBottom: 11,
		itemStyle: {
			width: 300,
			fontFamily: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontFamily: "Poppins",
				fontWeight: "bold",
				color: "#333",
				fontSize: "12px",
			},
		},
	},

	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			data: [],
			showInLegend: true,
			dataLabels: {
				enabled: true,
				format: "<b>{point.name}</b><br>{point.y}",
				distance: -50,
				filter: {
					property: "percentage",
					operator: ">",
					value: 4,
				},
				textDecoration: "none",
				style: {
					textDecoration: "none",
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "15px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	drilldown: {
		series: [],
	},
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 300,
				},

				chartOptions: {
					legend: {
						align: "center",
						verticalAlign: "bottom",
						layout: "horizontal",
						x: 0,
						y: -60,
						floating: true,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "100%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["50%", "30%"],
						},
					},
					series: [
						{
							events: {
								click: function (event) {},
							},
							marker: {
								fillColor: "black",
							},
							states: {
								hover: {
									enabled: true,
									opacity: 1,
								},
							},
							name: "",
							allowPointSelect: false,
							data: [],
							size: "70%",
							innerSize: "60%",
							showInLegend: true,
							dataLabels: {
								distance: -20,
								enabled: true,
								format: "",
								textDecoration: "none",
								style: {
									textDecoration: "none",
									fontFamily: "Poppins",
									fontWeight: "bold",
									fontSize: "10px",
									color: "white",
									stroke: "none",
									fill: "none",
									opacity: 1,
								},
							},
						},
					],
				},
			},
		],
	},
};
//-----------------------------------------
//My Timesheet Graph
export const optionsPie = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		marginRight: 10,
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			load: addTitle,
			redraw: addTitle,
		},
	},
	colors: [
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
	],
	title: {
		text: ``,
		x: 0,
		y: 0,
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
			cursor: "pointer",
			point: {
				events: {
					click: function () {
						sessionStorage.removeItem("TopBarTab");
						sessionStorage.removeItem("TopBarItem");
						sessionStorage.setItem("NavbarTab", "GeneralTasks");
						sessionStorage.setItem(
							"NavbarItem",
							"MyTimeSheetStatus"
						);
						window.location.href = `${Routes.MyTimeSheetStatus}/${this.name}`;
					},
				},
			},
		},
		pie: {
			allowPointSelect: true,
			size: "70%",
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			center: ["20%", "40%"],
		},
	},
	tooltip: {
		enabled: true,
		pointFormat: `{point.y:.0f}`,
	},

	legend: {
		layout: "horizontal",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 300,
		y: -30,
		x: 70,
		itemMarginTop: 0,
		itemMarginBottom: 11,
		itemStyle: {
			width: 100,
			fontFamily: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontWeight: "bold",
				fontFamily: "Poppins",
				color: "#333",
				fontSize: "12px",
			},
		},
	},

	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			allowPointSelect: false,
			data: [],
			size: "70%",
			innerSize: "65%",
			showInLegend: true,
			dataLabels: {
				distance: -17,
				enabled: true,
				format: "",
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 300,
				},

				chartOptions: {
					chart: {
						renderTo: "container",
						type: "pie",
						plotBackground: "transparent",
						marginRight: 10,
						margin: [0, 0, 0, 0],
						spacingTop: 0,
						spacingBottom: 0,
						spacingLeft: 0,
						spacingRight: 0,
					},
					title: {
						text: ``,
						y: 130,
						x: -10,
						style: {
							fontFamily: "Poppins",
							fontWeight: "bold",
							fontSize: "10px",
							color: "#4D4F5C",
							opacity: 1,
						},
					},
					legend: {
						align: "center",
						verticalAlign: "bottom",
						layout: "horizontal",
						x: 0,
						y: -60,
						floating: true,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontFamily: "Poppins",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "100%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["50%", "30%"],
						},
					},
					series: [
						{
							events: {
								click: function (event) {},
							},
							marker: {
								fillColor: "black",
							},
							states: {
								hover: {
									enabled: true,
									opacity: 1,
								},
							},
							name: "",
							allowPointSelect: false,
							data: [],
							size: "70%",
							innerSize: "60%",
							showInLegend: true,
							dataLabels: {
								distance: -20,
								enabled: true,
								format: "",
								style: {
									fontFamily: "Poppins",
									fontWeight: "bold",
									fontSize: "10px",
									color: "white",
									stroke: "none",
									fill: "none",
									opacity: 1,
								},
							},
						},
					],
				},
			},
		],
	},
};
function addTitle() {
	if (this.title) {
		this.title.destroy();
	}

	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;

	this.title = r
		.text(`Weeks<br><p style="font-size:21px">\xa0\xa0\xa005</p>`, 0, 0)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 20,
			color: "#4D4F5C",
			opacity: 1,
		})
		.hide()
		.add();

	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}
//---------------------------------------
export const timehseetPerformance = {
	chart: {
		renderTo: "timesheetPerformance",
		type: "column",
		marginTop: 40,
		events: {
			drilldown: function (e) {
				this.yAxis[0].setTitle({ text: "Score" });
			},
			drillup: function (e) {
				this.yAxis[0].setTitle({ text: "Number of Timesheets" });
			},
			events: {
				fullscreenClose: function () {
					this.renderTo.scrollIntoView({
						behavior: "smooth",
					});
				},
			},
		},
	},
	colors: [
		"#3fa3a6",
		"#A3E4D7",
		"#C6D68F",
		"#E6B0AA",
		"tomato",
		"#339900",
		"#99cc33",
		"#ffcc00",
		"#ff9966",
		"#cc3300",
	],
	title: {
		text: "",
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	tooltip: {
		footerFormat: "</table>",
		//TO exclude 0
		formatter: function () {
			let points = this.points,
				result =
					'<b><span style="font-size:10px">' +
					points[0].key +
					"</span></b><table>";

			points.forEach((p) => {
				result +=
					'<tr><td style="color:' +
					p.series.color +
					';padding:0">' +
					(p.y !== 0
						? p.series.name +
						  ": </td>" +
						  '<td style="padding:0">' +
						  p.y +
						  "</td></tr>"
						: "");
			});

			result += "</table>";

			return result;
		},
		shared: true,
		useHTML: true,
	},
	plotOptions: {
		series: {
			stacking: "normal",
		},
	},
	credits: {
		enabled: false,
	},
	lang: {
		drillUpText: "<< Back",
	},
	series: [
		{
			events: {
				click: function (event) {},
			},
			data: [],
		},
	],
	xAxis: [
		{
			type: "category",
			labels: {
				format: "{value}",
			},
		},
	],
	yAxis: {
		title: {
			enabled: true,
			text: "Number of Timesheets",
		},
	},
	drilldown: {
		breadcrumbs: {
			showFullPath: false,
			formatter: function (level) {
				return `<- Back to Main`;
			},
		},
		series: [
			{
				events: {
					click: function (event) {},
				},
			},
		],
	},
};
//-----------------------------------------
//My Projects View Graphs
export const optionsProjPie = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		marginRight: 10,
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			load: addHoursTitle,
			redraw: addHoursTitle,
		},
	},
	colors: [
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
	],
	title: {
		text: "",
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	subtitle: {
		text: "",
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 0,
			textAlign: "center",
			color: "#FFFF",
			opacity: 0,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
		},

		pie: {
			allowPointSelect: true,
			size: "70%",
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			center: ["20%", "40%"],
		},
	},
	tooltip: {
		enabled: true,
		pointFormat: `{point.y:.1f}`,
	},

	legend: {
		layout: "vertical",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 500,
		y: -40,
		x: 250,
		itemMarginTop: 0,
		itemMarginBottom: 11,
		itemStyle: {
			width: 300,
			fontFamily: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontFamily: "Poppins",
				fontWeight: "bold",
				color: "#333",
				fontSize: "12px",
			},
		},
	},
	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			allowPointSelect: false,
			data: [],
			size: "70%",
			innerSize: "65%",
			showInLegend: true,
			dataLabels: {
				distance: -20,
				enabled: true,
				format: "",
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 300,
				},

				chartOptions: {
					legend: {
						align: "center",
						verticalAlign: "bottom",
						layout: "horizontal",
						x: 0,
						y: -60,
						floating: true,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "100%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["50%", "30%"],
						},
					},
					series: [
						{
							events: {
								click: function (event) {},
							},
							marker: {
								fillColor: "black",
							},
							states: {
								hover: {
									enabled: true,
									opacity: 1,
								},
							},
							name: "",
							allowPointSelect: false,
							data: [],
							size: "70%",
							innerSize: "60%",
							showInLegend: true,
							dataLabels: {
								distance: -20,
								enabled: true,
								format: "",
								style: {
									fontFamily: "Poppins",
									fontWeight: "bold",
									fontSize: "10px",
									color: "white",
									stroke: "none",
									fill: "none",
									opacity: 1,
								},
							},
						},
					],
				},
			},
		],
	},
};
function addHoursTitle() {
	let myTitle = "";
	myTitle = this.subtitle.textStr;
	if (this.title) {
		this.title.destroy();
	}

	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;
	this.title = r
		.text(
			`Hours<br><p style="font-size:21px">\xa0\xa0\xa0` +
				myTitle +
				"</p>",
			0,
			0
		)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 22,
			color: "#4D4F5C",
			opacity: 1,
			textAlign: "center",
		})
		.hide()
		.add();

	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}
//-----------------------------------------
//Supervisor View Graphs
export const SpOptionsPie = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		marginRight: 10,
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			load: addHoursSp,
			redraw: addHoursSp,
		},
	},
	colors: [
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
	],
	title: {
		text: ``,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	subtitle: {
		text: "",
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 0,
			color: "#FFFF",
			opacity: 0,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
		},

		pie: {
			allowPointSelect: true,
			size: "70%",
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			center: ["20%", "40%"],
		},
	},
	tooltip: {
		enabled: false,
	},

	legend: {
		layout: "horizontal",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 400,
		y: -30,
		x: 130,
		itemMarginTop: 0,
		itemMarginBottom: 11,
		itemStyle: {
			width: 300,
			font: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontFamily: "Poppins",
				fontWeight: "bold",
				color: "#333",
				fontSize: "12px",
			},
		},
	},
	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			allowPointSelect: false,
			data: [],
			size: "80%",
			innerSize: "60%",
			showInLegend: true,
			dataLabels: {
				distance: -28,
				enabled: true,
				format: "",
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 300,
				},
				chartOptions: {
					legend: {
						align: "right",
						verticalAlign: "bottom",
						layout: "horizontal",
						x: 0,
						y: 0,
						floating: true,
						width: 300,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "50%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["50%", "30%"],
						},
					},
					series: [
						{
							events: {
								click: function (event) {},
							},
							marker: {
								fillColor: "black",
							},
							states: {
								hover: {
									enabled: true,
									opacity: 1,
								},
							},
							name: "",
							allowPointSelect: false,
							data: [],
							size: "60%",
							innerSize: "50%",
							showInLegend: true,
							dataLabels: {
								distance: -20,
								enabled: true,
								format: "",
								style: {
									fontFamily: "Poppins",
									fontWeight: "bold",
									fontSize: "10px",
									color: "white",
									stroke: "none",
									fill: "none",
									opacity: 1,
								},
							},
						},
					],
				},
			},
		],
	},
};
function addHoursSp() {
	let myTitle = "";
	myTitle = this.subtitle.textStr;
	if (this.title) {
		this.title.destroy();
	}
	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;
	this.title = r
		.text(
			`Hours<br><p style="font-size:21px">\xa0\xa0` + myTitle + "</p>",
			0,
			0
		)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 22,
			color: "#4D4F5C",
			opacity: 1,
			textAlign: "center",
		})
		.hide()
		.add();

	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}

function addTeamWFHCount() {
	let count = "";
	count = this.subtitle.textStr;
	if (this.title) {
		this.title.destroy();
	}
	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;
	this.title = r
		.text(
			`WFH<br><p style="font-size:21px">\xa0\xa0\xa0` + count + "</p>",
			0,
			0
		)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 22,
			color: "#4D4F5C",
			opacity: 1,
			textAlign: "center",
		})
		.hide()
		.add();

	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}
function addTeamWFOCount() {
	let count = "";
	count = this.subtitle.textStr;
	if (this.title) {
		this.title.destroy();
	}
	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;
	this.title = r
		.text(
			`WFO<br><p style="font-size:21px">\xa0\xa0\xa0` + count + "</p>",
			0,
			0
		)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 22,
			color: "#4D4F5C",
			opacity: 1,
			textAlign: "center",
		})
		.hide()
		.add();

	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}
function addTeamWSCount() {
	let count = "";
	let myTitle = this.title.textStr;
	count = this.subtitle.textStr;
	if (this.title) {
		this.title.destroy();
	}
	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;
	this.title = r
		.text(
			myTitle +
				`<br><p style="font-size:21px">\xa0\xa0\xa0` +
				count +
				"</p>",
			0,
			0
		)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 22,
			color: "#4D4F5C",
			opacity: 1,
			textAlign: "center",
		})
		.hide()
		.add();

	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}

function addTeamCWFOCount() {
	let count = "";
	count = this.subtitle.textStr;
	if (this.title) {
		this.title.destroy();
	}
	let r = this.renderer,
		x = this.series[0].center[0] + this.plotLeft,
		y = this.series[0].center[1] + this.plotTop;
	this.title = r
		.text(
			`CWFO<br><p style="font-size:21px">\xa0\xa0\xa0\xa0\xa0` +
				count +
				"</p>",
			0,
			0
		)
		.css({
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 22,
			color: "#4D4F5C",
			opacity: 1,
			textAlign: "center",
		})
		.hide()
		.add();
	let bbox = this.title.getBBox();
	this.title
		.attr({
			x: x - bbox.width / 2,
			y: y,
		})
		.show();
}
//-------------------------------------
//CM View Graphs
export const lineOptions = {
	chart: {
		patternUnits: "userSpaceOnUse",
		type: "area",
	},

	colors: ["#86a1ff", "#fbb1d9", "#8C54FF"],

	title: {
		text: "",
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 12,
			color: "black",
		},
	},

	credits: {
		enabled: false,
	},
	xAxis: {
		categories: [],
		gridLineWidth: 1,
		title: {
			text: "Month",
		},
	},
	yAxis: {
		gridLineWidth: 1,
		title: {
			text: "Count",
		},
		plotLines: [
			{
				value: 0,
				width: 1,
			},
		],
	},
	plotOptions: {
		series: {
			cursor: "pointer",
			fillColor: {
				linearGradient: [180, 0, 0, 300],
				stops: [
					[0, "#2E5BFF1A"],
					[1, "#2E5BFF00"],
				],
			},
		},
	},
	tooltip: {
		format: "{point.y}",
		shared: true,
	},
	legend: {
		layout: "horizontal",
		align: "left",
		verticalAlign: "top",
		useHTML: true,
		squareSymbol: true,
		symbolHeight: 10,
		symbolWidth: 10,
		itemStyle: {
			itemWidth: 75,
			width: 150,
			color: "#43425D",
			fontWeight: "normal",
			fontSize: "12px",
			opacity: "1",
			fontFamily: "Poppins",
		},
	},
	series: [
		{
			name: "",
			data: [],

			marker: {
				symbol: "circle",
				fillColor: "white",
				lineColor: null,
				lineWidth: 2,
			},
		},
	],
};
export const lineOptionsByWeek = {
	chart: {
		patternUnits: "userSpaceOnUse",
		type: "area",
	},

	colors: ["#86a1ff", "#fbb1d9", "#8C54FF"],

	title: {
		text: "",
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 12,
			color: "black",
		},
	},

	credits: {
		enabled: false,
	},
	xAxis: {
		categories: [],
		gridLineWidth: 1,
	},
	loading: {
		showDuration: 1000,
	},
	yAxis: {
		gridLineWidth: 1,
		title: {
			text: "Count",
		},
		plotLines: [
			{
				value: 0,
				width: 1,
			},
		],
	},
	plotOptions: {
		series: {
			fillColor: {
				linearGradient: [180, 0, 0, 300],
				stops: [
					[0, "#2E5BFF1A"],
					[1, "#2E5BFF00"],
				],
			},
		},
	},
	tooltip: {
		format: "{point.y}",
		shared: true,
	},
	legend: {
		layout: "horizontal",
		align: "left",
		verticalAlign: "top",
		useHTML: true,
		squareSymbol: true,
		symbolHeight: 10,
		symbolWidth: 10,
		itemStyle: {
			itemWidth: 75,
			width: 190,
			color: "#43425D",
			fontWeight: "normal",
			fontSize: "12px",
			opacity: "1",
			overflow: "auto",
			textOverflow: "visible",
			fontFamily: "Poppins",
		},
	},
	series: [
		{
			name: "",
			data: [],

			marker: {
				symbol: "circle",
				fillColor: "white",
				lineColor: null,
				lineWidth: 2,
			},
		},
	],
};
export const TimesheetPerformanceLineChart = {
	chart: {
		patternUnits: "userSpaceOnUse",
		type: "area",
	},

	colors: [
		"#3fa3a6",
		"#A3E4D7",
		"#C6D68F",
		"#E6B0AA",
		"tomato",
		"#339900",
		"#99cc33",
		"#ffcc00",
		"#ff9966",
		"#cc3300",
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
	],

	title: {
		text: "",
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 12,
			color: "black",
		},
	},

	credits: {
		enabled: false,
	},
	xAxis: {
		categories: [],
		gridLineWidth: 1,
	},
	loading: {
		showDuration: 1000,
	},
	yAxis: {
		gridLineWidth: 1,
		title: {
			text: "Count",
		},
		plotLines: [
			{
				value: 0,
				width: 1,
			},
		],
	},
	plotOptions: {
		series: {
			cursor: "pointer",
			fillColor: {
				linearGradient: [180, 0, 0, 300],
				stops: [
					[0, "#2E5BFF1A"],
					[1, "#2E5BFF00"],
				],
			},
		},
	},
	tooltip: {
		format: "{point.y}",
		shared: true,
	},
	legend: {
		layout: "horizontal",
		align: "left",
		verticalAlign: "top",
		useHTML: true,
		squareSymbol: true,
		symbolHeight: 10,
		symbolWidth: 10,
		itemStyle: {
			itemWidth: 75,
			width: 150,
			color: "#43425D",
			fontWeight: "normal",
			fontSize: "12px",
			opacity: "1",
			fontFamily: "Poppins",
		},
	},
	series: [
		{
			name: "",
			data: [],

			marker: {
				symbol: "circle",
				fillColor: "white",
				lineColor: null,
				lineWidth: 2,
			},
		},
	],
};
export const TeamWorkStationCountChart = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		marginBottom: 5,
	},

	title: {
		verticalAlign: "middle",
		x: -4,
		y: 26,
		floating: true,
		text: [],
		style: {
			fontFamily: "Poppins",
			fontSize: 23,
			color: "#4D4F5C",
			opacity: 1,
		},
	},

	subtitle: {
		text: [],
		verticalAlign: "bottom",
		y: 16,
		style: {
			fontFamily: "Poppins",
			fontWeight: "500",
			fontSize: 19,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		pie: {
			size: "100%",
			allowPointSelect: true,
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			dataLabels: {
				enabled: false,
			},
			states: {
				hover: {
					enabled: false, //disable hover color
				},
			},
		},
	},
	tooltip: {
		formatter: function () {
			if (this.colorIndex === 0)
				return `<b>Leaves Availed: </b> ${this.y}`;
			return `<b>Remaining Leaves: </b> ${this.y}`;
		},
		style: {
			fontSize: 16,
		},
	},

	series: [
		{
			shadow: false,
			borderWidth: 1,
			borderShadow: false,
			allowPointSelect: false,
			size: "100%",
			innerSize: "60%",
			dataLabels: {
				distance: -17,
				enabled: true,
				marker: {
					fillColor: "black",
				},
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
			data: [],
		},
	],
};
export const SpOptionsPieWFO = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			load: addTeamWFOCount,
			redraw: addTeamWFOCount,
		},
	},
	colors: [
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
		"#a3a01b",
		"#C0C0C0",
		"#40E0D0",
		"#FBE7A1",
		"#7FFFD4",
		"#a3ab",
		"#a33012",
		"#7D0552",
		"#008999",
		"#DFFF00",
		"#DE3163",
		"#008001",
	],
	title: {
		text: ``,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	subtitle: {
		text: "",
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 0,
			color: "#FFFF",
			opacity: 0,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
		},

		pie: {
			allowPointSelect: true,
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			center: ["20%", "40%"],
		},
	},
	tooltip: {
		enabled: true,
		pointFormat: `WFH {point.y:.0f}`,
	},

	legend: {
		layout: "horizontal",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 400,
		y: -30,
		x: 130,
		itemMarginTop: 10,
		itemMarginBottom: 10,
		itemStyle: {
			width: 300,
			font: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontFamily: "Poppins",
				fontWeight: "bold",
				color: "#333",
				fontSize: "12px",
			},
		},
	},
	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			allowPointSelect: false,
			data: [],
			size: "70%",
			innerSize: "55%",
			showInLegend: true,
			dataLabels: {
				distance: -17,
				enabled: true,
				format: "",
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 400,
				},
				chartOptions: {
					legend: {
						floating: true,
						verticalAlign: "bottom",
						itemMarginTop: -20,
						itemMarginBottom: 30,
						width: 100,
						x: 10,
						y: 0,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
						navigation: {
							activeColor: "#3E576F",
							animation: true,
							arrowSize: 12,
							inactiveColor: "#CCC",
							style: {
								fontFamily: "Poppins",
								fontWeight: "bold",
								color: "#333",
								fontSize: "12px",
							},
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "30%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["40%", "40%"],
						},
					},
				},
			},
		],
	},
};
export const SpOptionsPieWFH = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		marginRight: 10,
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			load: addTeamWFHCount,
			redraw: addTeamWFHCount,
		},
	},
	colors: [
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
		"#a3a01b",
		"#C0C0C0",
		"#40E0D0",
		"#FBE7A1",
		"#7FFFD4",
		"#a3ab",
		"#a33012",
		"#7D0552",
		"#008999",
		"#DFFF00",
		"#DE3163",
		"#008001",
	],
	title: {
		text: ``,
		events: {
			click: function (event) {},
		},
		useHTML: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	subtitle: {
		text: "",
		events: {
			click: function (event) {},
		},
		useHTML: true,
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 0,
			color: "#FFFF",
			opacity: 0,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
		},
		pie: {
			allowPointSelect: true,
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			center: ["20%", "40%"],
		},
	},
	tooltip: {
		enabled: true,
		pointFormat: `CWFO {point.y:.0f}`,
	},

	legend: {
		layout: "horizontal",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 400,
		y: -30,
		x: 130,
		itemMarginTop: 10,
		itemMarginBottom: 10,
		itemStyle: {
			width: 300,
			font: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontFamily: "Poppins",
				fontWeight: "bold",
				color: "#333",
				fontSize: "12px",
			},
		},
	},
	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			allowPointSelect: false,
			data: [],
			size: "70%",
			innerSize: "55%",
			showInLegend: true,
			dataLabels: {
				distance: -17,
				enabled: true,
				format: "",
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 400,
				},
				chartOptions: {
					legend: {
						floating: true,
						verticalAlign: "bottom",
						itemMarginTop: -20,
						itemMarginBottom: 30,
						width: 100,
						x: 10,
						y: 0,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
						navigation: {
							activeColor: "#3E576F",
							animation: true,
							arrowSize: 12,
							inactiveColor: "#CCC",
							style: {
								fontFamily: "Poppins",
								fontWeight: "bold",
								color: "#333",
								fontSize: "12px",
							},
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "30%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["40%", "40%"],
						},
					},
				},
			},
		],
	},
};
export const SpOptionsPieCWFO = {
	chart: {
		renderTo: "container",
		type: "pie",
		plotBackground: "transparent",
		marginRight: 10,
		margin: [0, 0, 0, 0],
		spacingTop: 0,
		spacingBottom: 0,
		spacingLeft: 0,
		spacingRight: 0,
		events: {
			load: addTeamCWFOCount,
			redraw: addTeamCWFOCount,
		},
	},
	colors: [
		"#a3a0fb",
		"#55d8fe",
		"#ffda83",
		"#ff8373",
		"#d3c7d7",
		"#fbb1d9",
		"#86a1ff",
		"#E6B0AA",
		"#A3E4D7",
		"#B3B6B7",
		"#D5F5E3",
		"#F5DEB3",
		"#AFEEEE",
		"#F5DEB3",
		"#C6D68F",
		"#E8A09A",
		"#a3a01b",
		"#C0C0C0",
		"#40E0D0",
		"#FBE7A1",
		"#7FFFD4",
		"#a3ab",
		"#a33012",
		"#7D0552",
		"#008999",
		"#DFFF00",
		"#DE3163",
		"#008001",
	],
	title: {
		text: ``,
		events: {
			click: function (event) {},
		},
		useHTML: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 16,
			color: "#4D4F5C",
			opacity: 1,
		},
	},
	subtitle: {
		text: "",
		events: {
			click: function (event) {},
		},
		useHTML: true,
		verticalAlign: "middle",
		float: true,
		style: {
			fontFamily: "Poppins",
			fontWeight: "bold",
			fontSize: 0,
			color: "#FFFF",
			opacity: 0,
		},
	},
	credits: {
		enabled: false,
	},
	plotOptions: {
		series: {
			marker: {
				fillColor: "purple",
				lineWidth: 10,
				lineColor: "red",
			},
			states: {
				hover: {},
			},
		},
		pie: {
			allowPointSelect: true,
			cursor: "pointer",
			shadow: false,
			borderColor: "none",
			center: ["20%", "40%"],
		},
	},
	tooltip: {
		enabled: true,
		pointFormat: `WFH {point.y:.0f}`,
	},

	legend: {
		layout: "horizontal",
		align: "right",
		verticalAlign: "middle",
		floating: true,
		width: 400,
		y: -30,
		x: 130,
		itemMarginTop: 10,
		itemMarginBottom: 10,
		itemStyle: {
			width: 300,
			font: "Poppins",
			fontWeight: "normal",
			color: "#43425D",
			fontSize: "14px",
		},
		navigation: {
			activeColor: "#3E576F",
			animation: true,
			arrowSize: 12,
			inactiveColor: "#CCC",
			style: {
				fontFamily: "Poppins",
				fontWeight: "bold",
				color: "#333",
				fontSize: "12px",
			},
		},
	},
	series: [
		{
			events: {
				click: function (event) {},
			},
			marker: {
				fillColor: "black",
			},
			states: {
				hover: {
					enabled: true,
					opacity: 1,
				},
			},
			name: "",
			allowPointSelect: false,
			data: [],
			size: "70%",
			innerSize: "55%",
			showInLegend: true,
			dataLabels: {
				distance: -17,
				enabled: true,
				format: "",
				style: {
					fontFamily: "Poppins",
					fontWeight: "bold",
					fontSize: "13px",
					color: "white",
					stroke: "none",
					fill: "none",
					opacity: 1,
				},
			},
		},
	],
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 400,
				},
				chartOptions: {
					legend: {
						floating: true,
						verticalAlign: "bottom",
						itemMarginTop: -20,
						itemMarginBottom: 30,
						width: 100,
						x: 5,
						y: 0,
						squareSymbol: true,
						borderColor: null,
						itemStyle: {
							color: "#43425D",
							fontWeight: "normal",
							fontSize: "12px",
							opacity: "1",
						},
						navigation: {
							activeColor: "#3E576F",
							animation: true,
							arrowSize: 12,
							inactiveColor: "#CCC",
							style: {
								fontFamily: "Poppins",
								fontWeight: "bold",
								color: "#333",
								fontSize: "12px",
							},
						},
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							size: "30%",
							cursor: "pointer",
							shadow: false,
							borderColor: "none",
							center: ["40%", "40%"],
						},
					},
				},
			},
		],
	},
};
